import { Trans } from '@lingui/react/macro';
import { NoddiBasicCard } from 'noddi-ui-web';

export const EmptyDay = () => (
  <NoddiBasicCard>
    <p className='text-sm text-muted-foreground'>
      <Trans>No transfer orders this day.</Trans>
    </p>
  </NoddiBasicCard>
);
